"use client"

import { Menu } from "lucide-react"
import { FaShoppingCart } from "react-icons/fa" // Import cart icon
import "./Header.css"
import logo from "../Assets/namenew.png"
import { useState, useEffect } from "react"
import Sidebar from "./Sidebar"
import { Link, useNavigate } from "react-router-dom"
import { useCart } from "../Context/CartContext" // Import useCart hook

export default function Header({ isLoggedIn, onLogout }) {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const navigate = useNavigate()
  const { getCartTotals } = useCart() // Get cart totals from context
  const { itemCount } = getCartTotals() // Get item count

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  return (
    <>
      <header className={isScrolled ? "scrolled" : ""}>
        <nav className="navbar">
          {/* Sidebar Menu Button */}
          <button className="menu-button" onClick={toggleSidebar}>
            <Menu size={40} />
          </button>

          {/* Logo */}
          <Link to="/">
            <img
              src={logo || "/placeholder.svg"}
              alt="Logo"
              style={{
                width: "200px",
                height: "auto",
                paddingTop: "0",
                paddingBottom: "0",
              }}
            />
          </Link>

          {/* Conditional Button: Cart / Order Now */}
          {isLoggedIn ? (
            <Link to="/cart">
              <button className="order-button cart-button">
                <FaShoppingCart size={18} />
                Cart {itemCount > 0 && <span className="cart-badge">{itemCount}</span>}
              </button>
            </Link>
          ) : (
            <Link to="/login">
              <button className="order-button">Order Now</button>
            </Link>
          )}
        </nav>
      </header>

      {/* Sidebar Component */}
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
    </>
  )
}

